import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SignUpButton from '../../layout/navbar/sign-up-button';

const Container = styled.div`
  background-color: #1E2737;
  width: 100%;
  padding-bottom: 16px;
`;

const Img = styled.img`
  height: 200px;
  max-height: 200px;
  width: 100%;
  object-fit: cover;
  margin-bottom: 16px;
`;

const Headline = styled.div`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyHeader};
  font-weight: ${props => props.theme.fontWeightBold};
  font-size: 29px;
  line-height: 120%;
  margin-bottom: 16px;
  padding: 0 20px;
`;

const Byline = styled.div`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-weight: ${props => props.theme.fontWeightRegular};
  font-size: 19px;
  line-height: 130%;
  padding: 0 20px;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 30px;
  padding: 0 20px;
`;

const Link = styled.a`
  color: ${props => props.theme.bodyBackgroundColor};
  font-family: ${props => props.theme.fontFamilyBody};
  font-size: 14px;
  font-weight: ${props => props.theme.fontWeightHeavy};
  line-height: 34px;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin: 8px auto;

  &:hover {
    color: ${props => props.theme.bodyBackgroundColor};
    cursor: pointer;
  }
`;

export default function Mobile({ banner, signUpUrl, signInUrl }) {
  const {
    imageUrl,
    headline,
    byline,
    registerButtonCopy,
  } = banner;

  return (
    <Container>
      <Img src={imageUrl} />
      <Headline>{headline}</Headline>
      <Byline>{byline}</Byline>
      <ButtonContainer>
        <SignUpButton label={registerButtonCopy} signUpUrl={signUpUrl} />
        <Link href={signInUrl}>Sign In</Link>
      </ButtonContainer>
    </Container>
  );
}

Mobile.propTypes = {
  banner: PropTypes.shape({
    id: PropTypes.number.isRequired,
    headline: PropTypes.string.isRequired,
    byline: PropTypes.string,
    imageUrl: PropTypes.string.isRequired,
    registerButtonCopy: PropTypes.string,
  }).isRequired,
  signUpUrl: PropTypes.string.isRequired,
  signInUrl: PropTypes.string.isRequired,
};
